import * as React from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import { Link } from "react-router-dom";
import { users } from "@/api";
import { omit } from "@/util";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  .atitle {
    display: flex;
    width: 100%;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    margin-top: 30px;
    height: 80px;
    justify-content: center;
  }
`;

const Register: React.FunctionComponent = () => {
  const history = useHistory();
  const [downNumber, setDownNumber] = React.useState(0);
  const [phoneNumber, setPhoneNumber] = React.useState("");

  React.useEffect(() => {
    if (downNumber > 0) {
      setTimeout(() => {
        setDownNumber(downNumber - 1);
      }, 1000);
    }
  }, [downNumber]);

  const buttonTxt = React.useMemo(
    () => (downNumber === 0 ? "发送验证码" : `${downNumber} S`),
    [downNumber]
  );

  const handleSubmit = async (values: any) => {
    console.log('Received values of form: ', values);
    // values.username = values.phone;
    values.phoneNum = values.phone;
    values.checkCode = 123456
    const params: users.RegProps = omit(
      values,
      "cfmPassword"
    ) as users.RegProps;
    await users.regist(params);
    history.replace("/login");
  };

  const sendCaptcha = async () => {
    if (!/1[\d]{10}/.test(phoneNumber)) {
      message.error("手机号码不正确");
      return;
    }
    await users.sendcode(phoneNumber);
    setDownNumber(59);
  };

  const phoneChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setPhoneNumber(v);
  };

  return (
    <Container>
      <Form onFinish={handleSubmit}>
        <div className="atitle">
          <h2>注册</h2>
        </div>
        <Form.Item
          name="username"
          rules={[
            { required: true, message: "账号不能为空" },
            { max: 20, message: "账号不得超过20位" }
          ]}
        >
          <Input placeholder="请输入账号" />
        </Form.Item>
        <Form.Item
          name="phone"
          rules={[
            { required: true, message: "手机号码不能为空" },
            {
              pattern: /^1[3-9]\d{9}$/, // 正则表达式验证中国大陆手机号码
              message: "请输入有效的手机号码",
            }
          ]}
        >
          <Input placeholder="请输入手机号码" onChange={phoneChangeHandler} />
        </Form.Item>
        {/* <Form.Item
          name="username"
          rules={[{ required: true, message: "用户名不能为空" }]}
        >
          <Input placeholder="请输入用户名" />
        </Form.Item> */}
        <Form.Item
          name="password"
          rules={[
            { required: true, message: "密码不能为空" },
            { len: 6, message: "密码必须为6位数" },
          ]}
        >
          <Input type="password" placeholder="请输入密码" />
        </Form.Item>
        <Form.Item
          name="cfmPassword"
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                   // 密码长度为6位
                if (value && value.length !== 6) {
                  return Promise.reject(new Error("密码必须为6位数"));
                }
                return Promise.reject(new Error("两次输入的密码不一致"));
              },
            }),
          ]}
        >
          <Input type="password" placeholder="请再次输入密码" />
        </Form.Item>
        <Form.Item name="nickname">
          <Input placeholder="请输入昵称" />
        </Form.Item>

        {/* <Form.Item  >
          <Row gutter={8}>
            <Col span={16}>
              <Form.Item
                name="checkCode"
                noStyle
                // rules={[{ required: true, message: "验证码不能为空" }]}
              >
                <Input placeholder="请输入收到的验证码" defaultValue={123456}  />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button onClick={sendCaptcha} block style={{ width: "100%" }}>
                {buttonTxt}
              </Button>
            </Col>
          </Row>
        </Form.Item> */}

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            注册
          </Button>
          <Link to="/login" style={{ float: "right" }}>
            登录
          </Link>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default Register;
